module.exports = __webpack_public_path__ + "static/work47-4cc5a62302a357083d465786f7802e0c.jpg";